import { GradesType } from 'shared/constants/grades.types';

export const grades: GradesType = [
  { value: '1', label: '1 класс' },
  { value: '2', label: '2 класс' },
  { value: '3', label: '3 класс' },
  { value: '4', label: '4 класс' },
  { value: '5', label: '5 класс' },
  { value: '6', label: '6 класс' },
  { value: '7', label: '7 класс' },
  { value: '8', label: '8 класс' },
  { value: '9', label: '9 класс' },
  { value: '10', label: '10 класс' },
  { value: '11', label: '11 класс' },
  { value: '12', label: '12 класс' },
];
